import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { HotlineDescriptionListSkeleton } from '@/feature/hotline/component/HotlineDescriptionList';
import { HotlineProDetailTab, HOTLINE_PRO_DETAIL_TAB_VALUE_DETAIL, } from '@/feature/hotline/professional/detail/component/HotlineProDetailTab';
import { HotlineProDetailViewLayoutSkeleton } from '@/feature/hotline/professional/detail/component/HotlineProDetailViewLayout';
import { hotlineProDetailViewStyle } from '@/feature/hotline/professional/detail/index/page/style';
/**
 * 匿名ホットライン コンサル詳細 詳細内容ページ（スケルトン表示）
 */
export const HotlineProDetailViewSkeleton = () => {
    const style = hotlineProDetailViewStyle({ showTab: false });
    return (_jsxs(HotlineProDetailViewLayoutSkeleton, { children: [_jsx(HotlineProDetailTab, { activeValue: HOTLINE_PRO_DETAIL_TAB_VALUE_DETAIL, isSkeleton: true }), _jsx("div", Object.assign({ className: style.content() }, { children: _jsx(HotlineDescriptionListSkeleton, {}) }))] }));
};
